// v10/src/components/ModeChoiceModal.js
//
// Parte 4 — Registro rápido.
// Solo se muestra cuando el piloto tiene HABILITADAS ambas modalidades:
// checklist asistido y registro rápido. Le pide elegir en el momento, después
// de seleccionar la aeronave (el selector ya bloqueó los AOG).
//
// Si el piloto tiene una sola modalidad activa, App.js salta este modal y va
// directo a la pantalla correspondiente.

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ClipboardCheck, Zap, X } from 'lucide-react';

const ModeChoiceModal = ({ aircraft, darkMode, onChecklist, onQuickLog, onDismiss }) => {
  const text = darkMode ? 'white' : '#0f172a';
  const sub  = darkMode ? 'rgba(255,255,255,0.55)' : '#64748b';
  const bg   = darkMode ? '#111827' : 'white';

  const acName = aircraft
    ? `${aircraft.manufacturer || ''} ${aircraft.model_name || aircraft.name || ''}${aircraft.registration ? ' (' + aircraft.registration + ')' : ''}`.trim()
    : '';

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        style={{ position: 'fixed', inset: 0, zIndex: 95, background: 'rgba(0,0,0,0.6)',
                 backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center',
                 justifyContent: 'center', padding: 16 }}>
        <motion.div
          initial={{ scale: 0.92, y: 24 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.92, y: 24 }}
          style={{ width: '100%', maxWidth: 420, borderRadius: 24, background: bg,
                   boxShadow: '0 24px 60px rgba(0,0,0,0.35)',
                   border: darkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(0,0,0,0.08)' }}>

          <div style={{ padding: '20px 24px 12px',
                        borderBottom: darkMode ? '1px solid rgba(255,255,255,0.07)' : '1px solid #f1f5f9',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: text }}>¿Cómo querés volar?</h2>
              <p style={{ margin: '4px 0 0', fontSize: 12, color: sub }}>{acName}</p>
            </div>
            <button onClick={onDismiss}
              style={{ background: darkMode ? 'rgba(255,255,255,0.08)' : '#f1f5f9', border: 'none',
                       borderRadius: 10, width: 34, height: 34, cursor: 'pointer',
                       display: 'flex', alignItems: 'center', justifyContent: 'center', color: sub }}>
              <X style={{ width: 16, height: 16 }} />
            </button>
          </div>

          <div style={{ padding: '16px 24px 24px', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <motion.button
              type="button"
              onClick={onChecklist}
              whileHover={{ scale: 1.02, y: -1 }}
              whileTap={{ scale: 0.97 }}
              style={{
                display: 'flex', alignItems: 'center', gap: 14,
                padding: '14px 16px', borderRadius: 18, border: 'none',
                background: 'linear-gradient(135deg,#2563eb,#1d4ed8)',
                color: 'white', cursor: 'pointer', fontFamily: 'inherit',
                boxShadow: '0 8px 24px rgba(37,99,235,0.35)', textAlign: 'left',
              }}>
              <div style={{ width: 44, height: 44, borderRadius: 12,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <ClipboardCheck style={{ width: 22, height: 22 }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 2 }}>Checklist asistido</div>
                <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.85, lineHeight: 1.4 }}>
                  Repasá el chequeo prevuelo paso a paso con Valentina.
                </div>
              </div>
            </motion.button>

            <motion.button
              type="button"
              onClick={onQuickLog}
              whileHover={{ scale: 1.02, y: -1 }}
              whileTap={{ scale: 0.97 }}
              style={{
                display: 'flex', alignItems: 'center', gap: 14,
                padding: '14px 16px', borderRadius: 18, border: 'none',
                background: 'linear-gradient(135deg,#f59e0b,#f97316)',
                color: 'white', cursor: 'pointer', fontFamily: 'inherit',
                boxShadow: '0 8px 24px rgba(245,158,11,0.35)', textAlign: 'left',
              }}>
              <div style={{ width: 44, height: 44, borderRadius: 12,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Zap style={{ width: 22, height: 22 }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 2 }}>Registro rápido</div>
                <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.85, lineHeight: 1.4 }}>
                  Cargá horómetro y combustible directo, sin checklist.
                </div>
              </div>
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ModeChoiceModal;
